// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import api from '../../../api';
import ContextMenu from '../../ContextMenu';

export default class Header extends React.Component {
    constructor(props){
        super(props); 
        this.state = {
            data: {...props.data}
        }
    }
    
    componentDidUpdate = (prevProps) => {
        if(JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)){
            this.setState({data: {...this.props.data}});
        }
    };

    openFile = () => {
        window.open(`/document/${this.state.data.document}`, '_blank');
    }

    renderConfirmed = () => {
        let className;
        if (this.state.data.confirmed && !this.state.data.clientConfirmed){
            className = this.props.renderActionOpen ?  'column-confirmed-action' : 'column-confirmed'; 
        }
        else if (this.state.data.confirmed && this.state.data.clientConfirmed){
            className = this.props.renderActionOpen ?  'column-clientConfirmed-action' : 'column-clientConfirmed';
        }
        return (
            <div 
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
                title={this.state.data.confirmed && !this.state.data.clientConfirmed ? 'Awaiting Client Confirmation' : null}
            >
                <div
                    className={`spreadsheet-header-value ${className}`}
                    style={this.props.renderActionOpen ? {cursor: 'pointer'} : {}}
                    onClick={this.props.renderActionOpen ? () => {
                        window.open('/document/' + this.state.data.document, '_blank')   
                    }: undefined}
                >
                    {this.props.value}
                </div>
            </div>
        )
    }

    renderReconciles = () => {
        return (
            <div
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
            >
                <div
                    className={`spreadsheet-header-value ${this.props.showActions !== false?'icon-open':''}`}
                    style={this.props.renderActionOpen ? {cursor: 'pointer'} : {}}
                    onClick={this.props.renderActionOpen ? () => {
                        window.open('/document/' + this.state.data.document, '_blank')   
                    } : undefined}
                >
                    {
                        this.props.data.split&&
                        <img 
                            alt='split icon'
                            src='https://static.stax.ai/images/icons/calculated.png'
                            style={{
                                width: 16,
                                height: 16,
                                marginRight: 5,
                            }}
                        />
                    }
                    {this.props.value}
                </div>
                {
                    this.props.showActions !== false ? 
                    <div
                    className='spreadsheet-header-action icon icon-approve a'
                    onClick={async() => {
                        if (this.props.userEmail.endsWith('@stax.ai')){
                            this.setState({
                                data:{
                                    ...this.state.data,
                                    confirmed: true
                                }
                            })
                        }

                        else{
                            this.setState({
                                data:{
                                    ...this.state.data,
                                    confirmed: true,
                                    clientConfirmed: true
                                }
                            })
                        }

                        this.renderConfirmed()

                        await api.post('/tpa/statement/confirm', {
                            statementId: this.state.data.statement,
                            source: this.props.userEmail.endsWith('@stax.ai')? 'stax': 'tpa'
                        });
                        
                    }}
                >
                    Approve
                </div>: null
                }
            </div>
        )
    }

    renderError = () => {
        return (
            <div 
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
            >
                <div
                    className='spreadsheet-header-value icon-warn column-warning'
                >
                    {
                        this.props.data.split&&
                        <img 
                        alt='split icon'
                        src='https://static.stax.ai/images/icons/calculated.png'
                        style={{
                            width: 16,
                            height: 16,
                            marginRight: 5,
                        }}
                    />
                    }
                    {this.props.value}
                </div>
                {
                     this.props.showActions !== false? 
                     <div
                     className='spreadsheet-header-action icon-open a'
                     style={{cursor: 'pointer'}}
                     onClick={() => {
                         window.open('/document/' + this.state.data.document, '_blank')   
                     }}
                 >
                     Open file
                 </div>: null
                }

            </div>
        )
    }

    renderMissing = () => {
        return (
            <div 
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
            >
                <div
                    className='spreadsheet-header-value icon-warn column-error'
                >
                    {this.props.value}
                </div>
                {
                    this.props.showActions !== false? 
                    <div
                    className='spreadsheet-header-action icon-open a'
                    onClick={() => {

                        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

                        const columnKey = this.props.columnKey; 
                        const coverage = columnKey.split('-'); 

                        const month = months.indexOf(coverage[coverage.length - 1]);

                        const monthShort = new Date(2024, month, 1).toLocaleString('default', { month: 'short' });
                        const monthLong = new Date(2024, month, 1).toLocaleString('default', { month: 'long' });


                        const query = `"${this.state.data.account.number}" + ("${monthShort}" | "${monthLong}") + "${this.state.data.planYear}"`;
                        const params = new URLSearchParams(); 
                        params.set('from', 'root');
                        params.set('view', 'list');
                        params.set('format', 'doc');

                        window.open(`/search/${query}?${params.toString()}`, "_blank")
                    }}
                >
                    Find missing
                </div>: null
                }
               
            </div>
        )
    }

    renderNa = () => {
        return (
            <div 
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
            >
                <div
                    className='spreadsheet-header-value column-na'
                >
                    {this.props.value}
                </div>   
            </div>
        )
    }

    renderValue = () => {
        return (
            <div 
                className='spreadsheet-header-container'
                style={{
                    height: this.props.showActions !== false? 60: 30,
                }}
            >
                <div
                    className='spreadsheet-header-value'
                    style={{fontWeight: 700}}
                >
                    {this.props.value}
                </div>
            </div>
        )
    }

    render = () => {
        // What are the different cases we need to handle for the header?  
        // 1. It is confirmed and good to go. 
        // 2. It reconciles, but is not confirmed.  
        // 3. It does not reconcile... 
        // 4. It is missing. 
        // 5. This is a header we do not need anything special for (rowLabels, totals, etc...) 
        

        // Do we even have data? If not just render the value of the cell.
        const hasData = Object.keys(this.state.data??{}).length;
        const data = this.state.data; 
        const renderError = hasData && (data?.errors?.filter((error) => error?.level !== 'low' && error?.level !== 'none').length || (!data?.reconciles && !data?.missing && !data?.na)) ;
        const renderReconciles = hasData && data.reconciles && !renderError && ((this.props.userEmail.endsWith('@stax.ai') && !data.confirmed) || (!this.props.userEmail.endsWith('@stax.ai') && !data.clientConfirmed));
        const renderConfirmed = hasData && ((data.confirmed && this.props.userEmail.endsWith('@stax.ai')) || (data.clientConfirmed && !this.props.userEmail.endsWith('@stax.ai')));
        const renderMissing = hasData && data.missing === true; 
        const renderNa = hasData && data.na === true; 
        return (
            <th 
                className='spreadsheet-header'
                style={this.props.style}
                onContextMenu={(e) => {
                    e.preventDefault(); 
                    if(!this.props.contextMenuOptions || this.props.contextMenuOptions?.length === 0)
                        return; 
                    this.openMenu(e, {...this.props});
                }}
                title={
                    this.props.data?.split? 
                    `This statement has calculated values by subtracting amount's from ${this.props.data?.splitFrom?.join(", ")}.`:""
                }
            >
                {
                    renderConfirmed? this.renderConfirmed(): 
                    renderReconciles? this.renderReconciles():
                    renderMissing? this.renderMissing():
                    renderError? this.renderError():
                    renderNa? this.renderNa():
                    this.renderValue()
                }
                <ContextMenu
                    load={(open,close) => {
                        this.openMenu = open;
                        this.closeMenu = close;
                    }}
                    options={this.props?.contextMenuOptions??[]}
                    onClose={() => this.setState({ selected: [] })} 
                />
            </th>
        )
    }
    
}